import { Component, Input, OnInit } from '@angular/core';
import { VersionService } from '../../services/version/version.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule, MatNavList } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Route, RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from '../../models/navigationItem.model';
@Component({
  selector: 'app-menu-drawer',
  standalone: true,
  imports: [
    MatExpansionModule,
    MatSidenavModule,
    MatNavList,
    MatListModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './menu-drawer.component.html',
  styleUrl: './menu-drawer.component.scss',
})
export class MenuDrawerComponent implements OnInit {
  public ELEMENT_IDS = ELEMENT_IDS;
  @Input() drawerRef!: MatSidenav;
  @Input() routesData!: NavigationItem[];
  @Input() systemRoutesData!: NavigationItem[];

  appVersion!: string;

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.appVersion = this.versionService.getApplicationVersion();
  }

  toggleDrawer() {
    this.drawerRef.toggle();
  }

  isSingleRoute(route: Route) {
    return route?.children?.length === 0;
  }

  isGroupedRoute(route: Route) {
    if (route?.children) {
      if (!this.isMultiGroupedRoute(route)) {
        return route?.children?.length > 0;
      }
    }

    return false;
  }

  isMultiGroupedRoute(route: Route) {
    if (route?.children) {
      if (route?.children.length > 0) {
        const innerChild = route?.children.filter((r) => {
          if (r.children) {
            return r.children.length > 0;
          } else {
            return false;
          }
        });

        if (innerChild.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    }

    return false;
  }
}

const BASE_ELEMENT_ID: string = 'id_menu_drawer';
export const ELEMENT_IDS: { [key: string]: string } = {
  'cnt':                BASE_ELEMENT_ID + '_cnt',
  'cnt_header':         BASE_ELEMENT_ID + '_cnt_header',
  'cnt_main_menu':      BASE_ELEMENT_ID + '_cnt_main_menu',
  'cnt_system_menu':    BASE_ELEMENT_ID + '_cnt_system_menu',
  'lbl_title':          BASE_ELEMENT_ID + '_lbl_title',
  'lbl_sub_title':      BASE_ELEMENT_ID + '_lbl_sub_title',
  'lbl_version':        BASE_ELEMENT_ID + '_lbl_version',
  'sec_panel':          BASE_ELEMENT_ID + '_sec_panel',
  'lbl_panel':          BASE_ELEMENT_ID + '_lbl_panel',
  'nav_item':           BASE_ELEMENT_ID + '_nav_item',
  'lbl_nav_item':       BASE_ELEMENT_ID + '_lbl_nav_item',
};
